import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import FeedbackHmm from "./FeedbackHmm";
import FeedbackJuggle from "./FeedbackJuggle";
import FeedbackNotFound from "./FeedbackNotFound";
import FeedbackPopcorn from "./FeedbackPopcorn";
import FeedbackThinking from "./FeedbackThinking";
import * as FEEDBACK from "../constants/feedbackNames";
const Feedback = props => {
    switch (props.name) {
        case FEEDBACK.FEEDBACK_JUGGLE:
            return _jsx(FeedbackJuggle, Object.assign({}, props));
        case FEEDBACK.FEEDBACK_NOT_FOUND:
            return _jsx(FeedbackNotFound, Object.assign({}, props));
        case FEEDBACK.FEEDBACK_POPCORN:
            return _jsx(FeedbackPopcorn, Object.assign({}, props));
        case FEEDBACK.FEEDBACK_THINKING:
            return _jsx(FeedbackThinking, Object.assign({}, props));
        default:
            return _jsx(FeedbackHmm, Object.assign({}, props));
    }
};
export default Feedback;
